import { render, staticRenderFns } from "./popupReply.vue?vue&type=template&id=4b17b196&scoped=true&"
import script from "./popupReply.vue?vue&type=script&lang=js&"
export * from "./popupReply.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/popupReply.css?vue&type=style&index=0&id=4b17b196&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b17b196",
  null
  
)

export default component.exports